// extracted by mini-css-extract-plugin
export default {"icon":"FileType_icon__eS7AB"};